import EventEmitter from 'wolfy87-eventemitter';
export default new EventEmitter();
